// npm imports
import { ContentState, convertFromRaw, EditorState } from "draft-js";
import { Toastr } from "../revvComponents";
import { updateDocumentField } from "../actions/DocumentActions/services";

import { updateSection } from "../actions/DocumentActions/index";
import BaseCommand from "./baseCommand";
import { DOCUMENT_MODE, DOCUMENT_COMPONENT_TYPES } from "../constants/document";
import { getFormFieldsDiffList } from "../utils/editorUtils";
import { updateCellData } from "../components/RevvTable/utils";
import { getContentStateFromRawSectionData } from "../utils/components";

import getCompositeDecorator from "../components/CustomRevvEditor/decorator";

const HEADER_FOOTER_KEY_MAP = {
  HEADER: "header",
  FOOTER: "footer",
};

const updateComponentRequired = (
  updateReduxAlso,
  addedNewTextSection,
  isEditorUpdateCase,
  componentType,
) => {
  let updateFlag = true;
  if (componentType === "HTML" || componentType === "Table") {
    updateFlag = false;
  }
  if (componentType === "CoverPage" || componentType === "HeaderFooter") {
    if (isEditorUpdateCase) {
      updateFlag = false;
    } else {
      updateFlag = true;
    }
  }
  // as of now "updateReduxAlso" flag is being used to handle the
  // remove clause option from the section in template side &
  // for newly added component
  if (updateReduxAlso || addedNewTextSection) {
    updateFlag = true;
  }
  return updateFlag;
};

const getContentStateOfSection = (section, activeComponentMeta) => {
  let contentState = null;
  if (
    section.type === DOCUMENT_COMPONENT_TYPES.HTML ||
    section.type === DOCUMENT_COMPONENT_TYPES.PAGE_NUMBER
  ) {
    contentState = section.data;
  } else if (section.type === DOCUMENT_COMPONENT_TYPES.TABLE) {
    const {
      data: { data: tableData },
    } = section;
    const tableCell =
      tableData[activeComponentMeta.tableRowId].data[
        activeComponentMeta.tableColId
      ].data;
    contentState = tableCell.data;
  } else if (section.type === DOCUMENT_COMPONENT_TYPES.COVERPAGE) {
    const {
      data: { components },
    } = section;
    const correctSection = components[activeComponentMeta.componentId].content;
    contentState = getContentStateOfSection(
      correctSection,
      activeComponentMeta,
    );
  } else if (section.type === DOCUMENT_COMPONENT_TYPES.HEADER_FOOTER) {
    const { blockType } = activeComponentMeta;
    const HFKey = HEADER_FOOTER_KEY_MAP[blockType];
    const correctSection =
      section.data[HFKey].components[activeComponentMeta.componentId].content;
    contentState = getContentStateOfSection(
      correctSection,
      activeComponentMeta,
    );
  }

  return contentState;
};

const getGetEditorStateOfSection = (section, activeComponentMeta) => {
  let contentState = getContentStateOfSection(section, activeComponentMeta);
  if (contentState) {
    if (!(contentState instanceof ContentState)) {
      contentState = convertFromRaw(contentState);
    }
    const editorState = EditorState.createWithContent(
      contentState,
      getCompositeDecorator(),
    );
    return editorState;
  }
  return null;
};
class UpdateComponentCommand extends BaseCommand {
  constructor(componentData) {
    super();
    this.componentData = componentData;
    this.unDoable = this.componentData.unDoable !== false;
  }

  execute() {
    if (this.isRedo && this.componentData.oldSection.id) {
      this.redo();
    } else {
      const {
        mode,
        docID,
        isTemplateTypeForm,
        // components,
        oldSection,
        isMouseHover,
        updatedSection,
        updateDocumentComponentAction,
        updateSectionService,
        addedNewTextSection,
        change,
        activeComponent,
        updateReduxAlso,
        isEditorUpdateCase,
      } = this.componentData;

      const updateDocumentComponentAlso = updateComponentRequired(
        updateReduxAlso,
        addedNewTextSection,
        isEditorUpdateCase,
        updatedSection.type,
      );

      if (!isMouseHover && oldSection) {
        // Store current doc sections as a snapshot first then execute the below actions
        oldSection.componentMeta = updatedSection.componentMeta;
      }

      // const componentStatus = Object.keys(components).includes(
      //   updatedSection.id,
      // );

      // check if the updatedSection nis available or not
      // if (!componentStatus) {
      //   return null;
      // }

      // add olSection to updatesection
      // this will be used to get old dynamic fields
      updatedSection.fieldDiffList = {};
      if (mode === DOCUMENT_MODE.TEMPLATE) {
        let oldSectionData = {
          ...oldSection,
        };
        if (
          oldSection.type === DOCUMENT_COMPONENT_TYPES.TABLE &&
          activeComponent
        ) {
          const {
            componentMeta: { tableRowId, tableColId } = {},
            data: cellData,
          } = activeComponent;
          oldSectionData = {
            type: oldSection.type,
            data:
              tableRowId !== undefined && tableColId !== undefined
                ? updateCellData(oldSection.data, tableRowId, tableColId, {
                    data: cellData,
                  })
                : oldSection.data,
          };
        }
        updatedSection.fieldDiffList = getFormFieldsDiffList(
          oldSectionData,
          updatedSection,
        );
        if (
          JSON.stringify(updatedSection.fieldDiffList) !==
          JSON.stringify(oldSectionData.fieldDiffList)
        ) {
          this.componentData.updateDocumentComponentAction(updatedSection);
        }
      }

      // get new editor state for new added text components
      if (addedNewTextSection) {
        // get editor state
        let activeSection;
        let activeEditorState;
        let contentState;
        if (
          addedNewTextSection.type === DOCUMENT_COMPONENT_TYPES.HTML ||
          addedNewTextSection.type === DOCUMENT_COMPONENT_TYPES.PAGE_NUMBER
        ) {
          activeSection = { ...addedNewTextSection };
          contentState = addedNewTextSection.data;
        } else if (
          addedNewTextSection.type === DOCUMENT_COMPONENT_TYPES.TABLE
        ) {
          const cell00 = addedNewTextSection.data.data[0].data[0].data;
          contentState = cell00.data;
          activeSection = {
            ...addedNewTextSection,
            data: contentState,
          };
        }

        if (contentState) {
          if (!(contentState instanceof ContentState)) {
            contentState = getContentStateFromRawSectionData(
              { data: contentState },
              mode,
            );
          }
          activeEditorState = EditorState.createWithContent(
            contentState,
            getCompositeDecorator(),
          );
        }
        addedNewTextSection.activeEditorPayload = {
          section: activeSection,
          editorState: activeEditorState,
        };
      }
      if (!isMouseHover && (change === undefined || change === true)) {
        if (updateDocumentComponentAlso) {
          // Update redux first then make service call to avoid flicker issue
          updateDocumentComponentAction(updatedSection, addedNewTextSection);
        }

        if (
          isTemplateTypeForm &&
          mode === DOCUMENT_MODE.DOCUMENT &&
          updatedSection.type === DOCUMENT_COMPONENT_TYPES.TABLE &&
          updatedSection.clauseOptions &&
          updatedSection.clauseOptions.id
        ) {
          updateDocumentField(docID, [
            {
              id: updatedSection.clauseOptions.id,
              filler_type: "SENDER",
              value: updatedSection.data,
            },
          ])
            .then(() => {})
            // Update redux with old data if service call fails
            .catch(() => {
              if (updateDocumentComponentAlso) {
                updateDocumentComponentAction(oldSection);
              }
              Toastr.showToastr({
                type: "failure",
                message: "Oops, Something went wrong!!",
                timeout: 3000,
              });
            });
          // }
        } else {
          updateSectionService(updatedSection)
            .then(() => {
              /* this is an unkown condition
            kept this while refactoring, 
            effect unkown
            */
              if (
                isTemplateTypeForm &&
                mode === DOCUMENT_MODE.DOCUMENT &&
                updatedSection.type === DOCUMENT_COMPONENT_TYPES.COVERPAGE
              ) {
                this.componentData.toggleCoverpageView(true);
              }
            })
            // Update redux with old data if service call fails
            .catch(() => {
              if (updateDocumentComponentAlso) {
                updateDocumentComponentAction(oldSection);
              }
              Toastr.showToastr({
                type: "failure",
                message: "Oops, Something went wrong!!",
                timeout: 3000,
              });
            });
        }
      } else if (change === null) {
        if (updateDocumentComponentAlso) {
          updateDocumentComponentAction(updatedSection, addedNewTextSection);
        }
      }
    }
    return null;
  }

  undo() {
    const {
      mode,
      forceUpdateEditorSectionIdAction,
      forceUpdateLocalEditorState,
      // initActiveEditor,
      updatedSection,
      componentMeta,
    } = this.componentData;

    let { oldSection: section } = this.componentData;
    const activeComponentMeta = componentMeta || section.componentMeta;

    // Scroll section into view when do Undo
    if (section) {
      this.scrollIntoView(section.id);
    }

    // check if it was a composite component
    if (
      updatedSection.type === DOCUMENT_COMPONENT_TYPES.COVERPAGE &&
      section.oldCoverpageComponent
    ) {
      section = { ...section.oldCoverpageComponent.content };
    } else if (
      updatedSection.type === DOCUMENT_COMPONENT_TYPES.HEADER_FOOTER &&
      section.oldHeaderFooterComponent
    ) {
      section = { ...section.oldHeaderFooterComponent.content };
    }

    section.fieldDiffList = {};
    if (mode === DOCUMENT_MODE.TEMPLATE) {
      const oldSectionData = {
        ...updatedSection,
      };
      section.fieldDiffList = getFormFieldsDiffList(oldSectionData, section);
    }

    this.componentData.updateDocumentComponentAction(section, false);
    // update section in backend
    updateSection(mode)(section);

    delete section.fieldDiffList;
    let hoveredActiveComponentId = null;
    let clickedActiveComponentId = null;
    let clickedActiveComponentType = null;

    // set editor data
    if (activeComponentMeta) {
      hoveredActiveComponentId = activeComponentMeta.componentId;
      clickedActiveComponentId = activeComponentMeta.componentId;
      clickedActiveComponentType = activeComponentMeta.componentType;
    }

    if (updatedSection.type === DOCUMENT_COMPONENT_TYPES.COVERPAGE) {
      this.componentData.toggleCoverpageView(false);
    }

    // let tableRowId = 0;
    // let tableColId = 0;
    // if (updatedSection.type === "Table") {
    //   const {
    //     data: {
    //       attributes: { cellIDtoPosMapping },
    //     },
    //   } = updatedSection;

    //   const activeCellPosition =
    //     cellIDtoPosMapping[this.componentData.clickedActiveComponentId];
    //   tableRowId = activeCellPosition ? activeCellPosition[0] : 0;
    //   tableColId = activeCellPosition ? activeCellPosition[1] : 0;
    // }

    if (
      clickedActiveComponentType !== "HTML" &&
      clickedActiveComponentType !== "Table"
    ) {
      this.componentData.updateActiveComponentMeta({
        clickedActiveComponentId,
        clickedActiveComponentType,
        hoveredActiveComponentId,
        activeComponentMeta: {
          ...activeComponentMeta,
        },
      });
    }

    if (
      this.componentData.coverpageThemeActionLabel &&
      this.componentData.coverpageThemeActionLabel === "ApplyTableFormula"
    ) {
      this.componentData.coverpageThemeAction(null);
      setTimeout(() => {
        this.componentData.coverpageThemeAction("ApplyTableFormula");
      }, 0);
    }

    if (activeComponentMeta && activeComponentMeta.componentId) {
      let decideActiveCMPId = activeComponentMeta.componentId;
      if (activeComponentMeta.componentType === "Table") {
        decideActiveCMPId = activeComponentMeta.tableCellId;
      }
      if (
        activeComponentMeta.componentType === "HTML" ||
        (activeComponentMeta.componentType === "Table" &&
          activeComponentMeta.tableCellId) ||
        activeComponentMeta.componentType ===
          DOCUMENT_COMPONENT_TYPES.PAGE_NUMBER
      ) {
        const editorState = getGetEditorStateOfSection(
          section,
          activeComponentMeta,
        );

        if (editorState) {
          forceUpdateLocalEditorState({
            componentId: decideActiveCMPId,
            editorState,
          });
          // initActiveEditor(editorState, section, activeComponentMeta);
        }
      } else {
        forceUpdateEditorSectionIdAction(decideActiveCMPId);
      }
    }

    this.isRedo = true;
  }

  redo() {
    const {
      mode,
      componentMeta,
      forceUpdateEditorSectionIdAction,
      forceUpdateLocalEditorState,
      // initActiveEditor,
    } = this.componentData;

    let { updatedSection: section } = this.componentData;
    const activeComponentMeta = componentMeta || section.componentMeta;
    const { oldSection } = this.componentData;

    // Scroll section into view when do Redo
    if (section) {
      this.scrollIntoView(section.id);
    }

    if (!section.id) {
      section = section.content;
    }

    section.fieldDiffList = {};
    if (mode === DOCUMENT_MODE.TEMPLATE) {
      const oldSectionData = {
        ...oldSection,
      };
      section.fieldDiffList = getFormFieldsDiffList(oldSectionData, section);
    }
    updateSection(mode)(section);
    this.componentData.updateDocumentComponentAction(section, false);

    let hoveredActiveComponentId = null;
    let clickedActiveComponentId = null;
    let clickedActiveComponentType = null;

    // set editor data
    if (activeComponentMeta) {
      hoveredActiveComponentId = activeComponentMeta.componentId;
      clickedActiveComponentId = activeComponentMeta.componentId;
      clickedActiveComponentType = activeComponentMeta.componentType;
    }

    // let tableRowId = 0;
    // let tableColId = 0;
    // if (section.type === "Table") {
    //   const {
    //     data: {
    //       attributes: { cellIDtoPosMapping },
    //     },
    //   } = section;

    //   const activeCellPosition =
    //     cellIDtoPosMapping[this.componentData.clickedActiveComponentId];
    //   tableRowId = activeCellPosition ? activeCellPosition[0] : 0;
    //   tableColId = activeCellPosition ? activeCellPosition[1] : 0;
    // }

    if (
      clickedActiveComponentType !== "HTML" &&
      clickedActiveComponentType !== "Table"
    ) {
      this.componentData.updateActiveComponentMeta({
        clickedActiveComponentId,
        clickedActiveComponentType,
        hoveredActiveComponentId,
        activeComponentMeta: {
          ...activeComponentMeta,
        },
      });
    }

    if (this.componentData.coverpageThemeActionLabel === "ApplyTableFormula") {
      this.componentData.coverpageThemeAction(null);
      setTimeout(() => {
        this.componentData.coverpageThemeAction("ApplyTableFormula");
      }, 0);
    }

    if (activeComponentMeta && activeComponentMeta.componentId) {
      let decideActiveCMPId = activeComponentMeta.componentId;
      if (activeComponentMeta.componentType === "Table") {
        decideActiveCMPId = activeComponentMeta.tableCellId;
      }
      if (
        activeComponentMeta.componentType === "HTML" ||
        (activeComponentMeta.componentType === "Table" &&
          activeComponentMeta.tableCellId) ||
        activeComponentMeta.componentType ===
          DOCUMENT_COMPONENT_TYPES.PAGE_NUMBER
      ) {
        const editorState = getGetEditorStateOfSection(
          section,
          activeComponentMeta,
        );

        if (editorState) {
          forceUpdateLocalEditorState({
            componentId: decideActiveCMPId,
            editorState,
          });
          // initActiveEditor(editorState, section, activeComponentMeta);
        }
      } else {
        forceUpdateEditorSectionIdAction(decideActiveCMPId);
      }
    }

    this.isRedo = false;
  }
}

export default UpdateComponentCommand;
